/*!
 * Karat utilities — email field validation/blocking.
 *
 * Catches dynamically-injected fields (Shopify popups, Econt shipping form,
 * predictive search) via event delegation, without needing to re-attach
 * listeners every time the DOM changes.
 */
(function () {
  'use strict';

  if (window.__karatUtilsLoaded) return;
  window.__karatUtilsLoaded = true;

 /* ---------- Email validator ---------- */
  // Event delegation: catches dynamically-injected fields (Shopify popups,
  // Econt shipping form, predictive search) without needing to re-attach
  // listeners every time the DOM changes.
  // Uses composedPath() to reach into open Shadow DOM (Shopify Forms popup).
  document.addEventListener('input', function (e) {
    // Walk the event path to find the real input — handles Shadow DOM cases
    // where event.target is the shadow host, not the actual input inside.
    var path = (typeof e.composedPath === 'function') ? e.composedPath() : [e.target];
    var t = null;
    for (var p = 0; p < path.length; p++) {
      if (path[p] && path[p].tagName === 'INPUT') { t = path[p]; break; }
    }
    if (!t) return;
    // Match any email-like field. Detection signals (any one is enough):
    //  1. type="email" on the input itself
    //  2. inputmode="email" (Econt form, some popups)
    //  3. name attribute contains "email" (Shopify checkout, contact forms)
    //  4. Lives inside a shopify-forms-embed shadow host (newsletter popup —
    //     has only one input, which is always email)
    var name = (t.name || '').toLowerCase();
    var inputMode = (t.getAttribute('inputmode') || '').toLowerCase();
    var insidePopup = false;
    for (var ph = 0; ph < path.length; ph++) {
      var node = path[ph];
      if (node && node.tagName === 'SHOPIFY-FORMS-EMBED') { insidePopup = true; break; }
    }
    var isEmailField =
      t.type === 'email' ||
      inputMode === 'email' ||
      name === 'contact[email]' ||
      name === 'customer[email]' ||
      name === 'email' ||
      name.indexOf('email') !== -1 ||
      insidePopup;
    if (!isEmailField) return;
    // Construct a synthetic event-like object pointing to the real input.
    onEmailInput({ target: t });
  }, { passive: true, capture: true });

  // Cyrillic detection: catches homograph attacks (gmail.сom with Cyrillic с/о)
  // and accidental keyboard-layout typos (typing email with BG keyboard active).
  // Real Latin-domain emails never contain Cyrillic characters.
  var CYRILLIC_REGEX = /[\u0400-\u04FF]/;

  function onEmailInput(e) {
    var v = e.target.value;
    if (!v) return;
    var lower = v.toLowerCase().trim();

    // ╔══════════════════════════════════════════════════════════════╗
    // ║  CYRILLIC CHARACTER CHECK                                    ║
    // ║  Catches homograph attacks and BG keyboard-layout mistakes.  ║
    // ║  Real Latin-domain emails never contain Cyrillic letters.    ║
    // ╚══════════════════════════════════════════════════════════════╝
    if (CYRILLIC_REGEX.test(v)) {
      alert('Имейл адресът не трябва да съдържа символи на кирилица. Моля, въведете адреса с букви на латиница.');
      e.target.value = '';
      return;
    }

    // ╔══════════════════════════════════════════════════════════════╗
    // ║  EXACT EMAIL ADDRESSES TO BLOCK                              ║
    // ║  Add specific addresses here, one per line, in lowercase.    ║
    // ║  Matches the full address only — exact match.                ║
    // ╚══════════════════════════════════════════════════════════════╝
    var blockedEmails = [
      'koruev_1988@abv.ro',
      'koruevivancvetanov@gmail.com',
      'koruev_1988@abv.fr',
      // 'example@gmail.com',
      // 'troublemaker@example.com',
    ];
    for (var i = 0; i < blockedEmails.length; i++) {
      if (lower === blockedEmails[i]) {
        alert('Unable to access');
        e.target.value = '';
        return;
      }
    }

    // ╔══════════════════════════════════════════════════════════════╗
    // ║  EMAIL DOMAINS TO BLOCK                                      ║
    // ║  Each entry must start with @ and be lowercase.              ║
    // ║  Matches anywhere in the address.                            ║
    // ║  Includes: privacy providers, disposable services, common    ║
    // ║  typos of major providers (gmail, yahoo, hotmail, abv.bg).   ║
    // ╚══════════════════════════════════════════════════════════════╝
    var blockedDomains = [
      // Proton (privacy-focused)
      '@protonmail.com',
      '@proton.me',
      '@pm.me',
      '@protonmail.ch',

      // Tutanota / Tuta (privacy-focused)
      '@tutanota.com',
      '@tutanota.de',
      '@tuta.io',
      '@tuta.com',

      // Other privacy-focused providers
      '@mailfence.com',
      '@hushmail.com',
      '@startmail.com',
      '@countermail.com',
      '@posteo.net',
      '@disroot.org',
      '@riseup.net',

      // Disposable / temporary email services
      '@guerrillamail.com',
      '@mailinator.com',
      '@10minutemail.com',
      '@temp-mail.org',
      '@tempmail.com',
      '@yopmail.com',
      '@throwaway.email',
      '@trashmail.com',
      '@maildrop.cc',
      '@dispostable.com',
      '@getnada.com',
      '@sharklasers.com',

      // Non-existent TLD variants (used by scammers)
      '@abv.ro',
      '@abv.fr',

      // Common typos of abv.bg (Bulgaria's largest free provider)
      '@abc.bg',
      '@abg.bg',
      '@abv.gb',
      '@abv.bgg',
      '@abv.cm',
      '@abv.bh',
      '@abv.gg',
      '@avb.bg',

      // Common typos of gmail.com
      '@gmial.com',
      '@gmai.com',
      '@gmaill.com',
      '@gnail.com',
      '@gmail.cmo',
      '@gmail.con',
      '@gmsil.com',
      '@gmali.com',

      // Common typos of yahoo.com
      '@yaho.com',
      '@yahooo.com',
      '@yhoo.com',
      '@yahho.com',

      // Common typos of hotmail.com
      '@hotmial.com',
      '@hotnail.com',
      '@hotmaill.com',
      '@hotmali.com',
      '@hotmil.com',

      // Common typos of outlook.com
      '@outlok.com',
      '@outloook.com',
      '@outlock.com',

      // Common typos of mail.bg
      '@mial.bg',
      '@mail.gb',
      '@mail.bgg',
    ];
    for (var j = 0; j < blockedDomains.length; j++) {
      if (lower.indexOf(blockedDomains[j]) !== -1) {
        alert('Въвели сте грешен имейл адрес');
        e.target.value = '';
        return;
      }
    }
  }
})();